import request from '@/utils/request'

export function getSiteInfo() {
  return request({ url: '/admin/config/siteInfo', method: 'post', data: {} })
}

export function getConfigList() {
  return request({ url: '/admin/config/list', method: 'post', data: {} })
}

export function updateConfig(updates) {
  return request({ url: '/admin/config/update', method: 'post', data: { updates } })
}
